<template>
    <section id="part-detail-product-spec" class="part-detail-section">
        <a id="part-detail-product-specs-link" class="part-detail-section-link" tabindex="-1"></a>
        <h2 class="part-page-heading">{{ $t("PartDetail.ProductSpecifications") }}</h2>
        <div id="product-specs" class="panel panel-default">
            <dl class="table">
                <div
                    v-for="(spec, index) in specs"
                    :key="spec.Key"
                    class="table-row border-gray-200"
                    :class="index > 0 && 'border-t'">
                    <dt class="table-cell p-2 lg:w-[312px] bg-gray-50">
                        {{ spec.Key }}
                    </dt>
                    <dd class="table-cell p-2">
                        <a
                            v-if="spec.Key === 'Series' && props.partResult.ProductSeriesUrl"
                            :href="props.partResult.ProductSeriesUrl">
                            {{ spec.Value }}
                        </a>
                        <span v-else>{{ spec.Value }}</span>
                    </dd>
                </div>
            </dl>
        </div>
    </section>
</template>
<script setup>
const props = defineProps({ partResult: { type: Object, required: true } });
const specs = computed(() => props.partResult.Specs);
</script>
